import React, { useEffect, useRef, useState } from 'react'

// react redux
import { connect } from 'react-redux'

// API's
import { getGoogleShoppingCategories } from 'utlis/Apis/GoogleShopping_API';

// includes
import SingleList from './SingleList'

// uuid
import uuid from 'react-uuid';

// toast
import { toast } from 'react-toastify'

// app messages
import {
    ERROR_WHILE__NAME,
    UNKNOWN_ERROR_OCCURED
} from 'utlis/AppMessages/AppMessages'

function CategoriesListing(props) {
    // props
    const {
        authState,
        defaultValue,

        getSelectedCategory
    } = props

    // refs
    const valueFieldRef = useRef(null)

    // states
    const [categoriesLoading, setCategoriesLoading] = useState(false)
    const [categoriesList, setCategoriesList] = useState([])
    const [selectedCategory, setSelectedCategory] = useState("")
    const [selectedCategoryOption, setSelectedCategoryOption] = useState("")
    const [isDropdownOpened, setIsDropdownOpened] = useState(false)
    const [openedListIds, setOpenedListIds] = useState([])

    // on value change
    const handleValueChange = ev => {
        const inpVal = ev.target.value
        setSelectedCategory(inpVal) // setting inp value
    }

    // on Option change
    const handleOptionChange = ev => {
        const inpVal = ev.target.value
        setSelectedCategoryOption(inpVal) // setting option value
        setSelectedCategory(inpVal) // setting inp value

        getSelectedCategory && getSelectedCategory(inpVal) // sending data back to the parent componente

        setTimeout(() => {
            setIsDropdownOpened(false) // closing the dropdown
        }, 500);
    }

    // on value change
    const handleDropdownExpand = (ev, id) => {
        ev.preventDefault()
        ev.stopPropagation()

        if (id) {
            const idFound = openedListIds.find(item => item === id)
            if (idFound) {
                const filteredList = openedListIds.filter(item => item !== id)

                setOpenedListIds(filteredList)
            } else {
                setOpenedListIds([...openedListIds, id])
            }
        }
    }

    // if default value exists
    useEffect(() => {
        if (defaultValue) {
            setSelectedCategoryOption(defaultValue) // setting option value
            setSelectedCategory(defaultValue) // setting inp value
        }
    }, [defaultValue])


    // getting google categories data
    useEffect(() => {
        // get converted categories
        const getConvertedCategories = data => {
            if (Object.keys(data)?.length) {
                const dataUpdated = []
                for (const key in data) {
                    if (Object.hasOwnProperty.call(data, key)) {
                        const value = data[key];

                        if (value && Object.keys(value)?.length) {
                            dataUpdated.push({
                                id: uuid().replaceAll("-", ""),
                                name: key,
                                subCats: getConvertedCategories(value)
                            })
                        } else {
                            dataUpdated.push({
                                id: uuid().replaceAll("-", ""),
                                name: key,
                                subCats: null
                            })
                        }
                    }
                }

                return dataUpdated
            }
        }

        // loading
        setCategoriesLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        Promise.all([
            getGoogleShoppingCategories(headers)
        ]).then(res => {
            // categories list
            (function () {
                const resData = res[0].data
                setCategoriesList(getConvertedCategories(resData)) // setting categories
            })();
        })

        // on click outside closing the element
        window.addEventListener('click', function () {
            setIsDropdownOpened(false)
        })
    }, [])

    return (
        <React.Fragment>
            <div
                className={`category-listing-main position-relative ${isDropdownOpened ? "active" : ""}`}
                onClick={ev => ev.stopPropagation()}>
                {/* head */}
                <div className={`head ${isDropdownOpened ? "active" : ""}`}>
                    <div className="inner" onClick={() => {
                        setIsDropdownOpened(true) // openning dropdown

                        valueFieldRef.current.focus() // focusing the input
                    }}>
                        <p className="label">Marketplace category</p>
                        <input
                            ref={valueFieldRef}
                            type="text"
                            className=""
                            value={selectedCategory}
                            placeholder="Select Category"
                            onChange={handleValueChange}
                        />
                    </div>
                </div>

                {
                    /* content */
                    isDropdownOpened ? (
                        <div className="dropdown-content position-absolute">
                            <div className="sc-inner border">
                                {
                                    categoriesList?.length ? categoriesList.map(item => (
                                        <React.Fragment key={item.id}>
                                            {
                                                item?.name?.length ? (
                                                    <SingleList
                                                        dataItem={item}

                                                        handleDropdownExpand={(ev, id) => handleDropdownExpand(ev, id)}
                                                        handleValueChange={handleOptionChange}

                                                        openedListIds={openedListIds}

                                                        selectedCategoryOption={selectedCategoryOption}
                                                    />
                                                ) : null
                                            }
                                        </React.Fragment>
                                    )) : null
                                }
                            </div>
                        </div>
                    ) : null
                }
            </div>
        </React.Fragment>
    )
}


const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(CategoriesListing)